import { defineMessages } from "react-intl";

export const messages = defineMessages({
  buttonLabel: {
    id: "meetingtemplatelist.item.button.change",
    defaultMessage: "Change",
    description: "change button label",
  },
});
